(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-sections-template"]) return;
  try {
    
  var $carousel = $('#product-image-two-cols-inner');
  // var $thumbCarousel = $('#product-image-two-cols-wrapper-thumbs');

  $carousel.slick(JSON.parse($carousel.attr('data-slick')));
  // $thumbCarousel.slick(JSON.parse($thumbCarousel.attr('data-slick')));

  // if ($('#product-image-two-cols-wrapper').length > 0 && $('#product-image-two-cols-inner .product__thumb').length > 1 && $(window).width() < 768) {
  //   $thumbCarousel.remove();
  // }

  if ($('.product-wishlist').length !== 0 && window.triggerSwymVariantEvent) {
    $(document).on('variantChange', (event) => window.triggerSwymVariantEvent(event.variant.id));
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template"]) return;
  try {
    
  var $carousel = $('#product-image-two-cols-inner');
  // var $thumbCarousel = $('#product-image-two-cols-wrapper-thumbs');

  $carousel.slick(JSON.parse($carousel.attr('data-slick')));
  // $thumbCarousel.slick(JSON.parse($thumbCarousel.attr('data-slick')));
  
  // if ($('#product-image-two-cols-wrapper').length > 0 && $('#product-image-two-cols-inner .product__thumb').length > 1 && $(window).width() < 768) {
  //   $thumbCarousel.remove();
  // }

  if ($('.product-wishlist').length !== 0 && window.triggerSwymVariantEvent) {
    $(document).on('variantChange', (event) => window.triggerSwymVariantEvent(event.variant.id));
  }

  } catch(e) { console.error(e); }
})();
})();
